export default __webpack_public_path__ + "static/media/EmptyBarGraph.1f727a48.svg";